import { render, staticRenderFns } from "./DashboardFolders.vue?vue&type=template&id=8b433a38&scoped=true&"
import script from "./DashboardFolders.vue?vue&type=script&lang=js&"
export * from "./DashboardFolders.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFolders.vue?vue&type=style&index=0&id=8b433a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b433a38",
  null
  
)

export default component.exports